<template>
  <div class="node">
    <div class="content">
      <comtitle title = "节点"></comtitle>
      <div class="allnode">
        <h3><span class="node-num">{{totalNodes}}</span><span class="noed-n">个节点</span></h3>
        <h4>{{nowTime}}</h4>
      </div>
      <table>
        <thead>
          <tr>
            <th>排名</th>
            <th>国家</th>
            <th>节点数</th>
          </tr>
        </thead>
        <tbody>
          <tr v-show="isLoading">
            <td colspan="3"><beat-loader :loading="isLoading" :num="5"></beat-loader></td>
          </tr>
          <tr v-for = "(item,index) in nodesList" :key="index">
            <td>{{index+1}}</td>
            <td>{{item.name}}</td>
            <td>{{item.value}}({{item.percent}})</td>
          </tr>
        </tbody>
      </table>
    </div>  
  </div>
</template>
<script>
import comtitle from "@/components/comtitle.vue";
import { myFetch } from "@/assets/js/api.js";
import beatLoader from '@/components/beatLoader';
import nodesBase from "./node.base.js";
export default {
  components: {
    comtitle,
    beatLoader
  },
  mixins: [nodesBase],
  methods: {
    getNodesInfo() {
      this.isLoading = true;
      let params = {
        jsonrpc: "2.0",
        id: 1,
        method: "NetScan.PeersLocation",
        params: []
      };
      myFetch(params, "/map").then(data => {
        this.netScanRespHandleBase(data);
      });
    },
  }
};
</script>
<style lang="scss" scoped>
.node {
  // background: #f3f3f3;
  // padding: 10px 13px;
  position: absolute;
  top: 24vw;
  bottom: 0;
  left: 0;
  right: 0;
  background:linear-gradient(0deg,rgba(255,255,255,1),rgba(239,245,252,1));
  .content{
    padding: 0 3vw 4vw;
  }
  .allnode {
    width: 100%;
    height: 1.8rem;
    background: #fff;
    margin: 0.15rem 0 0.28rem;
    h3 {
      height: 0.96rem;
      line-height: 0.96rem;
      text-align: center;
      .node-num {
        font-size: 20px;
        color: #D9A73A;
        padding-right: 0.1rem;
      }
      .node-n{
        color:#5D6187;
      }
    }
    h4 {
      font-size: 14px;
      color: #999;
      text-align: center;
    }
  }
  table {
    width: 100%;
    box-shadow:3px 0px 13px 0px rgba(229,235,243,1);
    thead,
    tbody {
      width: 100%;
      height: 1.09rem;
      line-height: 1.09rem;
      th {
        width: 33%;
        color: #333;
        background: #fff;
        text-align: center;
      }
      td {
        width: 33%;
        color: #999;
        text-align: center;
      }
    }
    tbody {
      tr {
        background: #fff;
      }
      tr:nth-of-type(odd) {
        background: #f9f9f9;
      }
    }
  }
}
</style>